import { axiosWithAuth } from "helpers";

export const merchantResidualsService = {
	getResidualsInformation,
	setResidualsInformation,
	setHighRiskMarker,
	setResidualsStatus,
};

type SetResidualsInformation = {
	splitProfileId?: string | null;
	scheduleAId?: string | null;
};

const API_URL = process.env.REACT_APP_API_URL;

function getResidualsInformation(merchantId: string) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/merchants/${merchantId}/residuals`,
	};

	return axiosWithAuth(options).then(data => ({
		splitProfileId: data.split_profile_id,
		scheduleAId: data.schedule_a_id,
		isHighRisk: data.is_high_risk,
		isHighRiskSplitProfileOverridden:
			data.is_high_risk_split_profile_overriden,
		residualsStatus: data.status,
		statusUpdatedBy: data.status_updated_by,
		withholdReason: data.withhold_reason,
	}));
}

function setResidualsStatus(
	merchantId: string,
	{
		residualsStatus,
		withholdReason,
	}: { residualsStatus: number | string | null; withholdReason?: number },
) {
	const options = {
		method: "POST",
		data: {
			status: residualsStatus,
			withhold_reason: withholdReason || undefined,
		},
		url: `${API_URL}/api/merchants/${merchantId}/residuals/change_status`,
	};

	return axiosWithAuth(options);
}

function setHighRiskMarker(merchantId: string, isHighRisk: string) {
	const options = {
		method: "POST",
		data: isHighRisk,
		url: `${API_URL}/api/merchants/${merchantId}/residuals/change_high_risk`,
	};

	return axiosWithAuth(options);
}

function setResidualsInformation(
	merchantId: string,
	data: SetResidualsInformation,
) {
	const options = {
		method: "PUT",
		data: {
			split_profile_id: data?.splitProfileId,
			schedule_a_id: data?.scheduleAId,
		},
		url: `${API_URL}/api/merchants/${merchantId}/residuals`,
	};

	return axiosWithAuth(options);
}
